const GO_ZERO_TIME = "0001-01-01T00:00:00Z";

export function isValidDateString(
  dateString: string | null | undefined
): boolean {
  if (dateString === null || dateString === undefined || dateString === "") {
    return false;
  }

  if (dateString === GO_ZERO_TIME) {
    return false;
  }

  const parsed = new Date(dateString);
  if (isNaN(parsed.getTime())) {
    return false;
  }

  return true;
}
